import styles from "./styles.module.scss";
import iconMedal from "../../../../assets/icon-medal.svg";
import iconBrain from "../../../../assets/icon-brain.svg";
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import { IChipsDto, IHardSkillsDto } from "../../../../@types/curriculum.type";

interface SkillsProps {
  skills: IChipsDto[];
  type: string;
  editable?: boolean;
  setValue?: React.Dispatch<React.SetStateAction<IHardSkillsDto[]>>;
}

export const ChipsSkill: React.FC<SkillsProps> = ({
  skills,
  type,
  editable,
  setValue
}) => {

  function displayIcon(){
    switch (type) {
      case "softskill":
        return <img className={styles.brain} src={iconBrain}></img>
      case "hardskill":
        return <img className={styles.medal} src={iconMedal}></img>
      case "experiences":
        return <PsychologyOutlinedIcon />
      default:
        break;
    }
  }

  function addChipsSkill(){
    const html = [];
    for (let index = 0; index < skills.length; index++) {
      const element = skills[index];
      html.push(
        <div className={styles.skill} key={element.description}>
          { displayIcon() }
          {element.description} 
        </div>
      );
    }
    return html;
  }

  return (
    <>
      {addChipsSkill()}
    </>
  );
};
